module.exports = __webpack_public_path__ + "files/a4ab28832bb65b3812b62b6282ab43e5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-4.png
// module id = 522
// module chunks = 76